import React, { useMemo } from 'react'
import {
  Table,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { getCurrencyFormatParts } from '@vend/utilities'

import { useRetailerSettingsManager } from '../../../ng-compat/hooks'
import { Movement } from '../utils/types'
import { CashMovementRow } from './CashMovementRow'

interface Props {
  movements: Movement[]
}

export const CashMovementsList: React.FC<Props> = ({ movements }) => {
  const retailerSettingsManager = useRetailerSettingsManager()
  const { culture, currency } = retailerSettingsManager.get()
  const currencySymbol = useMemo(
    () =>
      getCurrencyFormatParts(culture, currency.code, currency.symbol).symbol,
    [culture, currency]
  )

  return (
    <Table fixed>
      <TableHead>
        <TableRow type="header">
          <TableHeadCell width="15%">
            <T _str="Date" _context="TableHeadCell" />
          </TableHeadCell>
          <TableHeadCell className="wr-hide-on-mobile" width="30%">
            <T _str="User" _context="TableHeadCell" />
          </TableHeadCell>
          <TableHeadCell className="wr-hide-on-tablet">
            <T _str="Types" _context="TableHeadCell" />
          </TableHeadCell>
          <TableHeadCell width="15%" align="right" className="vd-pr0">
            <T
              _str="Transactions ({currencySymbol})"
              currencySymbol={currencySymbol}
              _context="TableHeadCell"
            />
          </TableHeadCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {movements.map(movement => (
          <CashMovementRow movement={movement} key={movement.id} />
        ))}
      </TableBody>
    </Table>
  )
}
